<template>
<transition name="fade">
    <div class="loading-main">
        <div class="loading">
            <div class="loading-gif animation_x"></div>
            <p>loading...</p>
        </div>
    </div>
</transition>
</template>
<style lang="scss" scoped>
.loading-gif {
    margin: 0 auto;
    width: 24px;
    height: 24px;
    margin-top: 25px;
    background-image: url('../../assets/images/loading-bg.png');
    background-size: cover;
}
.animation_x {
    -webkit-animation: 0.925s linear infinite backwards;
    -webkit-animation-name: loadDemo;
}
@-webkit-keyframes loadDemo {
    0% {
        -webkit-transform:rotate(0deg);
    }
    100% {
        -webkit-transform:rotate(360deg);
    }
}
.loading-main{
    position: fixed;
    width: 100%;height: 100%;
    left: 0;
    top: 0;
    z-index: 999999;
}
.loading {
    width: 100px;
    height: 100px;
    background: rgba(0,0,0,0.75);
    position: fixed;
    z-index: 99;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    text-align: center;
    border-radius: 10px;
    p{
        padding-top: 10px;
        color: #efefef;
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>
<script>
export default {
    data() {
        return {
            msg: 'loading'
        }
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?8b345d46